import { RenovationArea, SimpleDuration } from "__generated__/graphql";
import { z } from "zod";

export const organizationInfoSchema = z.object({
  organization: z.string().min(1, "Organization Name is required"),
  roleInOrganization: z.string().min(1, "Role in organization is required"),
  industry: z.string().optional(),
});

export const contactInfoSchema = z.object({
  firstName: z.string().min(1, "First name is required"),
  lastName: z.string().min(1, "Last name is required"),
  email: z.string().email("Please enter a valid email address"),
  phone: z.string().min(10, "Please enter a valid phone number"),
});

export const renovationDetailsSchema = z.object({
  projectLocation: z.string().min(1, "Project location is required"),
  intendedDuration: z.nativeEnum(SimpleDuration),
  areas: z.array(
    z.nativeEnum(RenovationArea)
  ).min(1, "Select at least one area"),
  otherArea: z.string().optional(),
  requiresStructuralChanges: z.boolean(),
});

export type OrganizationInfoFormData = z.infer<typeof organizationInfoSchema>;
export type RenovationContactInfoFormData = z.infer<typeof contactInfoSchema>;
export type RenovationDetailsFormData = z.infer<typeof renovationDetailsSchema>;


